export const headerHR = {
    "naslov": "FINA Validator",
    "o_nama": "O FINA Validatoru",
    "validateDoc": "Validator",
    "faq": "Često postavljena pitanja",
    "tos": "Opći uvjeti",
    "guide": "Upute",
    "lang": "Jezik: ",
    "cookies_policy": "Politika kolačića",
    "privacy_policy": "Politika privatnosti"
};